import jsPDF from "jspdf";

import html2canvas
  from "html2canvas";

// =========================
// EXPORTAR PANEL
// =========================

export const exportarPDF = async ({

  elementId,

  nombre = "documento"

}) => {

  const element =
    document.getElementById(
      elementId
    );

  if (!element) {

    alert(
      "Elemento no encontrado"
    );

    return;
  }

  const canvas =
    await html2canvas(

      element,

      {

        scale: 2,

        useCORS: true,

        backgroundColor:
          "#ffffff"
      }
    );

  const imgData =
    canvas.toDataURL(
      "image/png"
    );

  const pdf =
    new jsPDF({

      orientation:
        "portrait",

      unit: "mm",

      format: "a4"
    });

  const pdfWidth =
    pdf.internal.pageSize
      .getWidth();

  const pdfHeight =
    (
      canvas.height *
      pdfWidth
    ) / canvas.width;

  pdf.addImage(

    imgData,

    "PNG",

    0,

    0,

    pdfWidth,

    pdfHeight
  );

  pdf.save(
    `${nombre}.pdf`
  );
};